import { useQuery } from 'react-query'
import { serviceCardFromSanity } from '../../../../../api/api'
import { formatDateString } from '../../../../../utils/dateHelper'
import { addMonths } from 'date-fns'
import blockSerializer from '../../../../../data/blockSerializers'
import BlockContent from '@sanity/block-content-to-react'
import { Loader } from '../_shared/Loader'
import { Loading } from '../_shared/Loading'

export function ServiceCardBackside({ car, setShowServiceCard }) {
  const {
    data: serviceCard,
    isSuccess,
    isLoading,
  } = useQuery(['serviceCard'], () => serviceCardFromSanity())

  if (isLoading) {
    return (
      <Loading>
        <p>Henter servicekort informasjon...</p>
      </Loading>
    )
  }
  if (isSuccess) {
    return (
      <div className=" hideScrollBar overflow-hidden w-full">
        <div className="pb-4 flex flex-col gap-8">
          <h3 className="text-xl">
            {serviceCard?.[0]?.serviceCardheadingText?.nb}
          </h3>
          <div className="h-[1px] bg-slate-600 w-full" />
          <BlockContent
            serializers={blockSerializer}
            blocks={serviceCard?.[0]?.serviceCardBody?.nb}
          />
          <div className="h-[1px] bg-slate-600 w-full" />
          <div className="flex gap-5 md:gap-8">
            <div className="flex flex-col">
              <span className=" text-gray-400">Reg.nr</span>
              <span>{car?.registrationNumber}</span>
            </div>
            <div className="flex flex-col">
              <span className=" text-gray-400">Kortnummer</span>
              <span>{car?.budgetNo}</span>
            </div>
            <div className="flex flex-col">
              <span className=" text-gray-400">Utløpsdato</span>
              <span>
                {car.plannedReturnDate
                  ? formatDateString(
                      addMonths(new Date(car.plannedReturnDate), 1),
                    )
                  : 'Ukjent'}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return null
}
